<template>
  <v-row no-gutters style="height: 100%">
    <v-col style="height: 100%">
      <marking-assessment-list></marking-assessment-list>
    </v-col>
  </v-row>
</template>

<script>
  import MarkingAssessmentList from "../components/MainContent/Marking/MarkingAssessmentList";

  export default {
    name: "Mark",
    components: {MarkingAssessmentList},
    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
